// Shop background
import bockSbgAvif from "../assets/images/beers/bg/bock/bock-bg1024.avif"
import bockSbgWebp from "../assets/images/beers/bg/bock/bock-bg1024.webp"
import bockSbgJpg from "../assets/images/beers/bg/bock/bock-bg1024.jpg"

import juniperSbgAvif from "../assets/images/beers/bg/juniper/juniper-bg1024.avif"
import juniperSbgWebp from "../assets/images/beers/bg/juniper/juniper-bg1024.webp"
import juniperSbgJpg from "../assets/images/beers/bg/juniper/juniper-bg1024.jpg"

import kaskiSbgAvif from "../assets/images/beers/bg/kaski/kaski-bg1024.avif"
import kaskiSbgWebp from "../assets/images/beers/bg/kaski/kaski-bg1024.webp"
import kaskiSbgJpg from "../assets/images/beers/bg/kaski/kaski-bg1024.jpg"

import kesailtaSbgAvif from "../assets/images/beers/bg/kesailta/kesailta-bg1024.avif"
import kesailtaSbgWebp from "../assets/images/beers/bg/kesailta/kesailta-bg1024.webp"
import kesailtaSbgJpg from "../assets/images/beers/bg/kesailta/kesailta-bg1024.jpg"

import kevatkylmaSbgAvif from "../assets/images/beers/bg/kevatkylma/kevatkylma-bg1024.avif"
import kevatkylmaSbgWebp from "../assets/images/beers/bg/kevatkylma/kevatkylma-bg1024.webp"
import kevatkylmaSbgJpg from "../assets/images/beers/bg/kevatkylma/kevatkylma-bg1024.jpg"

import kuusenkerkkaSbgAvif from "../assets/images/beers/bg/kuusenkerkka/kuusenkerkka-bg1024.avif"
import kuusenkerkkaSbgWebp from "../assets/images/beers/bg/kuusenkerkka/kuusenkerkka-bg1024.webp"
import kuusenkerkkaSbgJpg from "../assets/images/beers/bg/kuusenkerkka/kuusenkerkka-bg1024.jpg"

import luotolampiSbgAvif from "../assets/images/beers/bg/luotolampi/luotolampi-bg1024.avif"
import luotolampiSbgWebp from "../assets/images/beers/bg/luotolampi/luotolampi-bg1024.webp"
import luotolampiSbgJpg from "../assets/images/beers/bg/luotolampi/luotolampi-bg1024.jpg"

import metsamarjaSbgAvif from "../assets/images/beers/bg/metsamarja/metsamarja-bg1024.avif"
import metsamarjaSbgWebp from "../assets/images/beers/bg/metsamarja/metsamarja-bg1024.webp"
import metsamarjaSbgJpg from "../assets/images/beers/bg/metsamarja/metsamarja-bg1024.jpg"

import pellavaSbgAvif from "../assets/images/beers/bg/pellava/pellava-bg1024.avif"
import pellavaSbgWebp from "../assets/images/beers/bg/pellava/pellava-bg1024.webp"
import pellavaSbgJpg from "../assets/images/beers/bg/pellava/pellava-bg1024.jpg"

import savusahtiSbgAvif from "../assets/images/beers/bg/savusahti/savusahti-bg1024.avif"
import savusahtiSbgWebp from "../assets/images/beers/bg/savusahti/savusahti-bg1024.webp"
import savusahtiSbgJpg from "../assets/images/beers/bg/savusahti/savusahti-bg1024.jpg"

import talviyoSbgAvif from "../assets/images/beers/bg/talviyo/talviyo-bg1024.avif"
import talviyoSbgWebp from "../assets/images/beers/bg/talviyo/talviyo-bg1024.webp"
import talviyoSbgJpg from "../assets/images/beers/bg/talviyo/talviyo-bg1024.jpg"

import tervaSbgAvif from "../assets/images/beers/bg/terva/terva-bg1024.avif"
import tervaSbgWebp from "../assets/images/beers/bg/terva/terva-bg1024.webp"
import tervaSbgJpg from "../assets/images/beers/bg/terva/terva-bg1024.jpg"

import yotaivasSbgAvif from "../assets/images/beers/bg/yotaivas/yotaivas-bg1024.avif"
import yotaivasSbgWebp from "../assets/images/beers/bg/yotaivas/yotaivas-bg1024.webp"
import yotaivasSbgJpg from "../assets/images/beers/bg/yotaivas/yotaivas-bg1024.jpg"

// Product background
import bockBgAvif from "../assets/images/beers/bg/bock/bock-bg.avif"
import bockBgWebp from "../assets/images/beers/bg/bock/bock-bg.webp"
import bockBgJpg from "../assets/images/beers/bg/bock/bock-bg.jpg"

import juniperBgAvif from "../assets/images/beers/bg/juniper/juniper-bg.avif"
import juniperBgWebp from "../assets/images/beers/bg/juniper/juniper-bg.webp"
import juniperBgJpg from "../assets/images/beers/bg/juniper/juniper-bg.jpg"

import kaskiBgAvif from "../assets/images/beers/bg/kaski/kaski-bg.avif"
import kaskiBgWebp from "../assets/images/beers/bg/kaski/kaski-bg.webp"
import kaskiBgJpg from "../assets/images/beers/bg/kaski/kaski-bg.jpg"

import kesailtaBgAvif from "../assets/images/beers/bg/kesailta/kesailta-bg.avif"
import kesailtaBgWebp from "../assets/images/beers/bg/kesailta/kesailta-bg.webp"
import kesailtaBgJpg from "../assets/images/beers/bg/kesailta/kesailta-bg.jpg"

import kevatkylmaBgAvif from "../assets/images/beers/bg/kevatkylma/kevatkylma-bg.avif"
import kevatkylmaBgWebp from "../assets/images/beers/bg/kevatkylma/kevatkylma-bg.webp"
import kevatkylmaBgJpg from "../assets/images/beers/bg/kevatkylma/kevatkylma-bg.jpg"

import kuusenkerkkaBgAvif from "../assets/images/beers/bg/kuusenkerkka/kuusenkerkka-bg.avif"
import kuusenkerkkaBgWebp from "../assets/images/beers/bg/kuusenkerkka/kuusenkerkka-bg.webp"
import kuusenkerkkaBgJpg from "../assets/images/beers/bg/kuusenkerkka/kuusenkerkka-bg.jpg"

import luotolampiBgAvif from "../assets/images/beers/bg/luotolampi/luotolampi-bg.avif"
import luotolampiBgWebp from "../assets/images/beers/bg/luotolampi/luotolampi-bg.webp"
import luotolampiBgJpg from "../assets/images/beers/bg/luotolampi/luotolampi-bg.jpg"

import metsamarjaBgAvif from "../assets/images/beers/bg/metsamarja/metsamarja-bg.avif"
import metsamarjaBgWebp from "../assets/images/beers/bg/metsamarja/metsamarja-bg.webp"
import metsamarjaBgJpg from "../assets/images/beers/bg/metsamarja/metsamarja-bg.jpg"

import pellavaBgAvif from "../assets/images/beers/bg/pellava/pellava-bg.avif"
import pellavaBgWebp from "../assets/images/beers/bg/pellava/pellava-bg.webp"
import pellavaBgJpg from "../assets/images/beers/bg/pellava/pellava-bg.jpg"

import savusahtiBgAvif from "../assets/images/beers/bg/savusahti/savusahti-bg.avif"
import savusahtiBgWebp from "../assets/images/beers/bg/savusahti/savusahti-bg.webp"
import savusahtiBgJpg from "../assets/images/beers/bg/savusahti/savusahti-bg.jpg"

import talviyoBgAvif from "../assets/images/beers/bg/talviyo/talviyo-bg.avif"
import talviyoBgWebp from "../assets/images/beers/bg/talviyo/talviyo-bg.webp"
import talviyoBgJpg from "../assets/images/beers/bg/talviyo/talviyo-bg.jpg"

import tervaBgAvif from "../assets/images/beers/bg/terva/terva-bg.avif"
import tervaBgWebp from "../assets/images/beers/bg/terva/terva-bg.webp"
import tervaBgJpg from "../assets/images/beers/bg/terva/terva-bg.jpg"

import yotaivasBgAvif from "../assets/images/beers/bg/yotaivas/yotaivas-bg.avif"
import yotaivasBgWebp from "../assets/images/beers/bg/yotaivas/yotaivas-bg.webp"
import yotaivasBgJpg from "../assets/images/beers/bg/yotaivas/yotaivas-bg.jpg"

// Bottles
import bockBottlePng from "../assets/images/beers/no-bg/bock/bock.png"
import juniperBottlePng from "../assets/images/beers/no-bg/juniper/juniper.png"
import kaskiBottlePng from "../assets/images/beers/no-bg/kaski/kaski.png"
import kesailtaBottlePng from "../assets/images/beers/no-bg/kesailta/kesailta.png"
import kevatkylmaBottlePng from "../assets/images/beers/no-bg/kevatkylma/kevatkylma.png"
import kuusenkerkkaBottlePng from "../assets/images/beers/no-bg/kuusenkerkka/kuusenkerkka.png"
import luotolampiBottlePng from "../assets/images/beers/no-bg/luotolampi/luotolampi.png"
import metsamarjaBottlePng from "../assets/images/beers/no-bg/metsamarja/metsamarja.png"
import pellavaBottlePng from "../assets/images/beers/no-bg/pellava/pellava.png"
import savusahtiBottlePng from "../assets/images/beers/no-bg/savusahti/savusahti.png"
import talviyoBottlePng from "../assets/images/beers/no-bg/talviyo/talviyo.png"
import tervaBottlePng from "../assets/images/beers/no-bg/terva/terva.png"
import yotaivasBottlePng from "../assets/images/beers/no-bg/yotaivas/yotaivas.png"

export const products = [
    {
        id: 1,
        name: "Mänty Bock",
        sbg: {
            avif: bockSbgAvif,
            webp: bockSbgWebp,
            fallback: bockSbgJpg
        },
        bg: {
            avif: bockBgAvif,
            webp: bockBgWebp,
            fallback: bockBgJpg
        },
        bottle: bockBottlePng,
        price: 4.90,
        alcohol: 6.7,
        volume: 0.33,
        style: "Tumma bock",
        fits: [
            'Nuotion äärelle', 
            'Ruokapöytään'
        ],
        story: [
            "Mänty Bock on kunnianosoitus suomalaisen metsän jylhälle rauhalle ja vanhoille juurille. Tämä tumma ja täyteläinen bock-olut syntyi halusta tuoda jotakin perinteikästä, mutta silti omaleimaista Mäntylän Panimon valikoimaan. ",
            "Innoitus sai alkunsa eräänä myöhäissyksyn iltana, kun panimon porukka istui ulkona vanhan männyn juurella. Ilmassa tuoksui kostea havumetsä, ja käsissä höyrysi ensimmäiset kokeelliset keitokset tulevasta bockista. Sen lämmin, maltainen runko ja hennon metsäinen katkeruus loivat heti tunteen siitä, että tämä olut ei ole pelkkä juoma – se on vuodenaika pullossa. ",
            "Mänty Bockissa maistuvat paahdetut maltaat, kevyt karamellisuus ja ripaus havuisuutta – aivan kuin sukeltaisi syvälle kuusikon siimekseen. Se on täydellinen valinta viileisiin iltoihin, rauhallisiin hetkiin ja niille, jotka etsivät syvyyttä jokaisesta siemauksesta."
        ]
    },
    {
        id: 2,
        name: "Juniper Pale Ale",
        sbg: {
            avif: juniperSbgAvif,
            webp: juniperSbgWebp,
            fallback: juniperSbgJpg
        },
        bg: {
            avif: juniperBgAvif,
            webp: juniperBgWebp,
            fallback: juniperBgJpg
        },
        bottle: juniperBottlePng,
        price: 4.70,
        alcohol: 5.2,
        volume: 0.33,
        style: "Pale Ale katajanmarjalla",
        fits: [
            'Kesäpäivän pelastaja', 
            'Saunajuoman kuningas'
        ],
        story: [
            "Juniper Pale Ale syntyi kaipuusta metsään – sinne, missä ilma on raikasta ja katajapensaat tuoksuvat auringon lämmössä. Tämä raikas, havuinen pale ale yhdistää modernin oluttyylin ja pohjoisen luonnon omaleimaisen sävyn: katajanmarjan. ",
            "Kataja ei ole pelkkä mauste – se on suomalaisen maiseman sielu. Panimolla haluttiin tuoda tuo maku olueen niin, että jokainen kulauksellinen veisi ajatukset kivikkorinteille ja valoisille mäntykankaille. Kevyen sitruksinen humalointi kohtaa katajan pihkaisen säväyksen, luoden persoonallisen mutta helposti lähestyttävän kokonaisuuden. ",
            "Juniper Pale Ale on kuin retkipäivän jälkeinen virkistävä hengähdys: raikas, kirkas ja mieleenpainuva."
        ]
    },
    {
        id: 3,
        name: "Kaski Red Ale",
        sbg: {
            avif: kaskiSbgAvif,
            webp: kaskiSbgWebp,
            fallback: kaskiSbgJpg
        },
        bg: {
            avif: kaskiBgAvif,
            webp: kaskiBgWebp,
            fallback: kaskiBgJpg
        },
        bottle: kaskiBottlePng,
        price: 4.80,
        alcohol: 5.5,
        volume: 0.33,
        style: "Red Ale",
        fits: [
            'Nuotion äärelle',
            'Ruokapöytään'
        ],
        story: [
            "Kaski Red Ale sai alkunsa tarinasta, joka on yhtä vanha kuin suomalainen maanviljelys – kasken poltosta. Siinä, missä metsä palaa hallitusti ja uusi kasvu versoo tuhkasta, syntyy myös tämä olut: lämmin, syvä ja mausteinen. ",
            "Panimolla haluttiin luoda jotain, jossa yhdistyvät punertavan oluen pehmeys ja maun moniulotteisuus. Kaski Red Ale rakentuu paahteisista maltaista, joissa on ripaus karamellisuutta ja hentoa savuisuutta – kuin muisto hiljalleen kytevästä kaskeaamusta. ",
            "Olut on suunniteltu nautittavaksi rauhassa – iltanuotiolla, syksyisessä metsässä tai yksinkertaisesti silloin, kun kaipaat jotain täyteläistä ja tasapainoista. Kaski ei huuda – se kertoo."
        ]
    },
    {
        id: 4,
        name: "Kesäilta Session Ipa",
        sbg: {
            avif: kesailtaSbgAvif,
            webp: kesailtaSbgWebp,
            fallback: kesailtaSbgJpg
        },
        bg: {
            avif: kesailtaBgAvif,
            webp: kesailtaBgWebp,
            fallback: kesailtaBgJpg
        },
        bottle: kesailtaBottlePng,
        price: 4.50,
        alcohol: 4.2,
        volume: 0.33,
        style: "Session IPA",
        fits: [
            'Kesäpäivän pelastaja', 
            'Darran selättäjä'
        ],
        story: [
            "Kesäilta Session IPA on pullotettu hetki suomalaista kesää. Se tuo mieleen lämpimän kallion, hyttysten surinan ja ilta-auringon, joka ei malta laskea horisonttiin. Tämä kepeä ja raikkaasti humaloitu session IPA on suunniteltu nautittavaksi silloin, kun illat venyvät – ja jano pysyy kevyenä. ", 
            "Panimolla haluttiin tehdä olut, jossa on täysi maku mutta kevyempi ote. Sitruunainen, trooppinen humalointi antaa oluelle eloisan luonteen, mutta matala alkoholipitoisuus mahdollistaa sen, että yksi ei jää viimeiseksi. ",
            "Kesäilta on yhteisiä nauruja, mökkilaiturin rauhaa ja vapauden tuntua – ja juuri siksi tämä olut on olemassa."
        ]
    },
    {
        id: 5,
        name: "Kevätkylmä Lager",
        sbg: {
            avif: kevatkylmaSbgAvif,
            webp: kevatkylmaSbgWebp,
            fallback: kevatkylmaSbgJpg
        },
        bg: {
            avif: kevatkylmaBgAvif,
            webp: kevatkylmaBgWebp,
            fallback: kevatkylmaBgJpg
        },
        bottle: kevatkylmaBottlePng,
        price: 4.50,
        alcohol: 4.7,
        volume: 0.33,
        style: "Helles Lager",
        fits: [
            'Darran selättäjä',
            'Kesäpäivän pelastaja'
        ],
        story: [
            "Kevät ei koskaan saavu huutaen. Se hiipii hiljaa yöpakkasten sekaan, rohkenee valoon ja sulattaa lumen kulman kerrallaan. Kevätkylmä Lager syntyi juuri tästä odotuksesta – siitä hetkestä, kun aurinko alkaa viipyä vähän pidempään ja ilma tuoksuu uudelta alulta. ",
            "Tämä vaalea, pehmeä ja hienostuneesti humaloitu lager on kunnianosoitus suomalaiselle keväälle. Kevätkylmä on täydellinen tasapaino raikkaan rapsakkuuden ja maltillisen makeuden välillä – kuin kylmä ilta auringonlaskun jälkeen, kun villapaita lämmittää vielä hetken ja kädessä on kylmä pullo jotain, mikä tuntuu oikealta."
        ]
    },
    {
        id: 6,
        name: "Kuusenkerkkä Ipa",
        sbg: {
            avif: kuusenkerkkaSbgAvif,
            webp: kuusenkerkkaSbgWebp,
            fallback: kuusenkerkkaSbgJpg
        },
        bg: {
            avif: kuusenkerkkaBgAvif,
            webp: kuusenkerkkaBgWebp,
            fallback: kuusenkerkkaBgJpg
        },
        bottle: kuusenkerkkaBottlePng,
        price: 5.20,
        alcohol: 5.5,
        volume: 0.33,
        style: "India Pale Ale maustettuna kuusenkerkällä",
        fits: [
            'Nuotion äärelle', 
            'Saunajuoman kuningas'
        ],
        story: [
            "Keväällä metsässä tuoksuu uudelta – maa herää, ja kuusenoksien päissä versoo vihreää. Siitä tuoreudesta, luonnon villistä voimasta ja kevään rohkeasta energiasta sai alkunsa Kuusenkerkkä IPA. ",
            "Ystävykset poimivat ensimmäiset kerkät käsin Mäntylän lähimetsästä, lisäten ne kokeellisesti IPA-eräänsä. Lopputulos yllätti: vahvasti humaloitu mutta pehmeä ja metsäinen, raikas ja havuinen – kuin keuhkot täynnä puhdasta metsäilmaa. ",
            "Kuusenkerkkä IPA yhdistää pohjoisen metsän aromit moderniin IPA-tyyliin. Se on tasapainoinen, hieman sitruksinen ja ilahduttavan erilainen – suomalainen metsä pullossa."
        ]
    },
    {
        id: 7,
        name: "Luotolampi Wheat Ale",
        sbg: {
            avif: luotolampiSbgAvif,
            webp: luotolampiSbgWebp,
            fallback: luotolampiSbgJpg
        },
        bg: {
            avif: luotolampiBgAvif,
            webp: luotolampiBgWebp,
            fallback: luotolampiBgJpg
        },
        bottle: luotolampiBottlePng,
        price: 4.80,
        alcohol: 4.8,
        volume: 0.33,
        style: "Vehnäolut",
        fits: [
            'Kesäpäivän pelastaja', 
            'Darran selättäjä'
        ],
        story: [
            "Hiljainen lammen pinta, jossa heijastuu pilvetön kesätaivas. Kaskisen saariston kupeessa oleva luotolampi oli paikka, johon ystävykset vetäytyivät hengittämään, ideoimaan – ja joskus myös maistelemaan uusia kokeiluja. Siellä syntyi ajatus oluesta, joka olisi yhtä lempeä ja kirkas kuin tuo hetki veden äärellä. ",
            "Luotolampi Wheat Ale on pehmeä, vaalean samea ja kevyesti sitruksinen vehnäolut, jossa pilkahtaa häivähdys kesän tuoksuja – appelsiininkuorta, hiivaa ja vaaleaa viljaa. Helposti lähestyttävä, mutta ei koskaan tylsä. Olut, joka rauhoittaa mutta ei turruta – kuin lintujen ääni ja laineiden liplatus kesäpäivänä."
        ]
    },
    {
        id: 8,
        name: "Metsämarja Stout",
        sbg: {
            avif: metsamarjaSbgAvif,
            webp: metsamarjaSbgWebp,
            fallback: metsamarjaSbgJpg
        },
        bg: {
            avif: metsamarjaBgAvif,
            webp: metsamarjaBgWebp,
            fallback: metsamarjaBgJpg
        },
        bottle: metsamarjaBottlePng,
        price: 5.40,
        alcohol: 5.9,
        volume: 0.33,
        style: "Marjastout",
        fits: [
            'Nuotion äärelle', 
            'Ruokapöytään'
        ],
        story: [
            "Kosteassa havumetsässä, poimittujen variksenmarjojen, mustikoiden ja puolukoiden keskellä syntyy muistoja, jotka eivät unohdu. Metsämarja Stout on kunnianosoitus suomalaiselle marjametsälle – hiljaiselle, mutta täynnä elämää. Se sai alkunsa, kun panijat halusivat yhdistää vahvan, paahteisen stoutin ja pohjoisen metsän omat makeat ja hapokkaat aarteet. ",
            "Tämä tumma olut tarjoaa syvän suklaan ja kahvin sävyjen taustalla kevyen vivahteen metsän marjoista – kuin hämärtyvä ilta mökillä, kun nokipannu kahisee ja käsissä on jotain samettista ja lämmittävää. Metsämarja Stout ei ole makea, vaan tasapainoinen – juuri sopivasti marjainen, jotta se herättää uteliaisuuden ja jättää jäljen."
        ]    
    },
    {
        id: 9,
        name: "Pellava Blonde Ale",
        sbg: {
            avif: pellavaSbgAvif,
            webp: pellavaSbgWebp,
            fallback: pellavaSbgJpg
        },
        bg: {
            avif: pellavaBgAvif,
            webp: pellavaBgWebp,
            fallback: pellavaBgJpg
        },
        bottle: pellavaBottlePng,
        price: 4.80,
        alcohol: 4.9,
        volume: 0.33,
        style: "Blonde Ale",
        fits: [
            'Kesäpäivän pelastaja', 
            'Darran selättäjä'
        ],
        story: [
            "Pellava Blonde Ale on kuin loppukesän pellon laita – vaalea, lempeä ja selkeälinjainen. Se sai alkunsa ajatuksesta luoda olut, joka olisi yhtä ajaton ja luonnollinen kuin pellavakangas: yksinkertainen, mutta täynnä sävyjä, kun sitä katsoo lähempää. ",
            "Pellava on helposti lähestyttävä, kevyt ja tasapainoinen ale, jossa viljaisuus saa seurakseen hienovaraisen kukkaisuuden ja aavistuksen hunajaista makeutta. Tämä olut ei huuda huomiota – se kutsuu viipyilemään. Ystävykset Mäntylän autotallipanimossa kehittivät sen ajatellen yhteisiä kesäiltoja, pitkiä pöytäkeskusteluja ja hetkiä, jolloin kaikki on kohdallaan."
        ]
    },
    {
        id: 10,
        name: "Savusahti Farmhouse Ale",
        sbg: {
            avif: savusahtiSbgAvif,
            webp: savusahtiSbgWebp,
            fallback: savusahtiSbgJpg
        },
        bg: {
            avif: savusahtiBgAvif,
            webp: savusahtiBgWebp,
            fallback: savusahtiBgJpg
        },
        bottle: savusahtiBottlePng,
        price: 5.60,
        alcohol: 6.2,
        volume: 0.33,
        style: "Farmhouse Ale, savumaltainen",
        fits: [
            'Saunajuoman kuningas',
            'Nuotion äärelle',
            'Ruokapöytään'
        ],
        story: [
            "Savusahti Farmhouse Ale on kunnianosoitus suomalaiselle sahtiperinteelle ja maatilan arjelle. Se yhdistää perinteisen savuisuuden rustiikkiseen farmhouse-tyyliin – syntyen jossain savusaunan, viljapellon ja vanhan navetan välimaastossa. ",
            "Tämä olut sai alkunsa kokeilusta, jossa ystävykset halusivat yhdistää savumaltaan syvän aromin modernin, kuivahkon ja hiivavetoisen farmhouse-oluen rakenteeseen. Tuloksena syntyi uniikki makumaailma: savuisen leipäinen, kevyesti hedelmäinen ja rohkean maalaishenkinen. ",
            "Savusahti ei ole helpoin eikä tavanomaisin olut – mutta se on rehellinen. Se vie ajatukset syksyisiin haravointipäiviin, saunailtoihin maalla ja savun tuoksuun, joka jää vaatteisiin ja muistoihin."
        ]
    },
    {
        id: 11,
        name: "Talviyö Winter Ale",
        sbg: {
            avif: talviyoSbgAvif,
            webp: talviyoSbgWebp,
            fallback: talviyoSbgJpg
        },
        bg: {
            avif: talviyoBgAvif,
            webp: talviyoBgWebp,
            fallback: talviyoBgJpg
        },
        bottle: talviyoBottlePng,
        price: 5.60,
        alcohol: 6.5,
        volume: 0.33,
        style: "Winter Ale",
        fits: [
            'Nuotion äärelle', 
            'Ruokapöytään'
        ],
        story: [
            "Talviyö on olut, joka syntyi pimeästä, mutta lämmittää valolla. Se on kunnianosoitus suomalaiselle talvelle – niille hetkille, kun pakkanen paukkuu nurkissa, tähdet näkyvät kirkkaina ja lumi hiljentää kaiken muun. ",
            "Ystävykset halusivat luoda oluen, joka sopisi juuri näihin hetkiin: tumma, täyteläinen ja mausteinen, mutta ei raskas. Talviyö on maustettu ripauksella neilikkaa, appelsiininkuorta ja paahdettua mallasta – kuin joulun ja nuotion välimaasto pullossa. ",
            "Se ei vaadi kiirettä eikä ääntä – vain villasukat, hyvä tuoli ja ehkä vähän lunta ikkunan takana."
        ]
    },
    {
        id: 12,
        name: "Tervaporter",
        sbg: {
            avif: tervaSbgAvif,
            webp: tervaSbgWebp,
            fallback: tervaSbgJpg
        },
        bg: {
            avif: tervaBgAvif,
            webp: tervaBgWebp,
            fallback: tervaBgJpg
        },
        bottle: tervaBottlePng,
        price: 5.60,
        alcohol: 6.8,
        volume: 0.33,
        style: "Porter, tervalla maustettu",
        fits: [
            'Nuotion äärelle',
            'Ruokapöytään'
        ],
        story: [
            "Tervaporter on kuin harmaa marraskuun ilta, jolloin sade ropisee kattoon ja ulkona tuoksuu märkä metsä ja vanha savusauna. Tämä olut ei ole kiireiselle – se on niille, jotka haluavat pysähtyä hetkeksi ja maistaa menneisyyttä. ",
            "Inspiraatio Tervaporteriin syntyi vanhasta tervatynnyristä, joka löytyi panokaverien isoisän liiteristä. Sen haju, tummuus ja historia olivat kuin lupaus siitä, että tästä tehdään jotain rohkeaa. Ja niin tehtiin. ",
            "Tervaporter yhdistää paahteisen porterin pehmeän rungon lempeän, mutta selkeän tervan aromiin. Lopputulos on syvä, savuinen ja hienostuneesti karhea – kuin kansanperinne pullossa."
        ]
    },
    {
        id: 13,
        name: "Yötaivas Imperial Stout",
        sbg: {
            avif: yotaivasSbgAvif,
            webp: yotaivasSbgWebp,
            fallback: yotaivasSbgJpg
        },
        bg: {
            avif: yotaivasBgAvif,
            webp: yotaivasBgWebp,
            fallback: yotaivasBgJpg
        },
        bottle: yotaivasBottlePng,
        price: 6.20,
        alcohol: 9.2,
        volume: 0.33,
        style: "Imperial Stout",
        fits: [
            'Nuotion äärelle', 
            'Ruokapöytään'
        ],
        story: [
            "Yötaivas syntyi hiljaisuudesta – siitä hetkestä, kun tähdet syttyvät metsän ylle ja koko maailma pysähtyy. Se on kunnianosoitus arktiselle pimeydelle, jonka keskellä pieni valo, lämpö ja vahva maku tuntuvat suuremmilta kuin koskaan. ",
            "Tämä imperial stout on Mäntylän Panimon voimakkain olut. Sen sydän sykkii paahteesta, tummasta suklaasta, lakritsista ja kevyestä kahvin vivahteesta. Täyteläinen runko ja pitkä jälkimaku tekevät siitä nautiskeluoluen, joka ei sovi kiireeseen – vaan hetkiin, jolloin haluat olla läsnä. ",
            "Yötaivas on olut, joka kertoo tarinoita – nuotion äärellä, villahuopien alla tai kynttilänvalossa."
        ]
    },
]